
import { Component, Prop, Provide, Vue, Watch } from 'vue-property-decorator'
import LoadingItem from '@/components/Splash/loadingItem.vue'
import FooterCom from '@/components/Footer/index.vue'

@Component({
  components: {
      LoadingItem,
      FooterCom
  },
  filters:{}
})
export default class Test extends Vue {
  
  /// props
  @Prop({ default: false }) private complete!: boolean
  @Prop() private error?: string
  
  /// data
  private data: Object = {}
  
  private productLoading: boolean = true
  private trackLoading: boolean = true
  private brandLoading: boolean = true
  
  /// provide data
  @Provide() provideData: Object = {}
  
  // computed
  private get infos(): Array<any> {
      return Array<any>()
  }
  
  /// lifecycle
  created() {
    
  }
  
  mounted() {
    setTimeout(()=>{
        this.productLoading = false
    }, 500)
    setTimeout(()=>{
        this.trackLoading = false
    }, 1200)
    // setTimeout(()=>{
    //     this.brandLoading = false
    // }, 4000)
  }
  
  /// methods
  public methodOne(params: any): void {
    
  }
  /// watch methods
  @Watch('complete', { immediate: true, deep: true })
  onArrayChanged(newVal: any, oldVal: any) {
      if(newVal){
          this.productLoading = false
          this.trackLoading = false
          this.brandLoading = false
      }
  }
}
